var SizeEnum = /* @__PURE__ */ ((SizeEnum2) => {
  SizeEnum2["xs"] = "xs";
  SizeEnum2["s"] = "s";
  SizeEnum2["m"] = "m";
  SizeEnum2["l"] = "l";
  SizeEnum2["xl"] = "xl";
  return SizeEnum2;
})(SizeEnum || {});

export { SizeEnum };
